<template>
  <AppDialog>
    <v-card>
      <v-card-title>Create New Order</v-card-title>
      <v-card-subtitle>
        <AppRow>
          <span>
            Form ID: <pre>{{ form.id }}</pre>
          </span>
          <span>
            Created: <pre>{{ form.created_at }}</pre>
          </span>
        </AppRow>
        <AppRow>
          <span>
            {{ form.client.name }}
            <br>
            {{ form.client.email }}
          </span>
          <span>
            {{ form.product.name }}
            <br>
            x{{ form.quantity }}
          </span>
        </AppRow>
      </v-card-subtitle>
      <v-card-text>
        <v-form :ref="setFormRef">
          <PaymentProcessorRadio v-model="processor" class="mb-7" />
          <AppRow>
            <TextField
              v-model.number="total"
              :rules="[required]"
              :label="`Total payed (${currency})`"
              type="numeric"
            />
            <TextField
              v-model="paymentId"
              :rules="[required]"
              label="Transaction ID"
            />
          </AppRow>
          <AppBtn primary :loading @click="create">
            Create Order
          </AppBtn>
        </v-form>
      </v-card-text>
    </v-card>
  </AppDialog>
</template>

<script setup lang="ts">
import { createOrder } from '~/helpers/http';
import { calcTotalPrice } from '~/helpers/price';
import type { PaymentProcessor, SerializedDb, VisaForm } from '~/types';

const props = defineProps<{
  form: SerializedDb<VisaForm>;
}>();

const emit = defineEmits(['created']);

const { required } = useValidation();
const { currency } = useBranch();
const { setFormRef, submit, loading } = useForm();

const processor = ref<PaymentProcessor>('bill');
const total = ref(calcTotalPrice(props.form, currency));
const paymentId = ref('');

async function create() {
  submit(async () => {
    const success = await createOrder({
      id: paymentId.value,
      amount: total.value,
      currency: currency.toUpperCase(),
      formId: props.form.id,
      processor: processor.value,
      completed: true
    });
    if (success) {
      emit('created');
    }
  }, { successMsg: 'Created order successfuly' });
}
</script>